import React from 'react';
import PropTypes from 'prop-types';
import Select from '../../_utils/select-wrapper';
import { DeliveryOption, PrintFinish } from '../prop-types';
import {
  selectedDeliveryOption,
  availableDeliveryOptionsForFinish,
} from '../common/finish-and-delivery-options';

const handleDeliveryChange = (
  value,
  deliveryOptions,
  onChange
) => {
  onChange({
    delivery_option: selectedDeliveryOption(deliveryOptions, value)
  });
};

const DeliverySelector = ({
  deliveryOptions,
  deliveryOption,
  finishesByDeliveryOption,
  finish,
  onChange,
}) => (
  <Select
    label="Delivery Method"
    aria-label="Select Delivery"
    value={deliveryOption.key}
    options={availableDeliveryOptionsForFinish(
      deliveryOptions,
      finishesByDeliveryOption,
      finish,
      true
    )}
    inputStyleLink
    withCaret
    onChange={value =>
      handleDeliveryChange(
        value,
        deliveryOptions,
        onChange
      )
    }
  />
);

DeliverySelector.propTypes = {
  deliveryOptions: PropTypes.arrayOf(DeliveryOption),
  deliveryOption: DeliveryOption,
  finishesByDeliveryOption: PropTypes.arrayOf(PrintFinish),
  finish: PrintFinish,
  onChange: PropTypes.func,
}.isRequired;

export default DeliverySelector;
